import { InventoryMutation } from "@domain/inventory/models/InventoryMutation";
import { ProductMapper } from "../../product/mappers/ProductMapper";
import { InventoryMutationDTO } from "../dto/InventoryMutationDto";
import { WarehouseMapper } from "./WarehouseMapper";
import { WarehouseConnectionMapper } from "./WarehouseConnectionMapper";
import { MutationType } from "@domain/inventory/enums/MutationType.enum";

export class InventoryMutationMapper {
    static toModel(dto: InventoryMutationDTO): InventoryMutation {
        return {
            id: dto.id,
            product: ProductMapper.toModel(dto.product),
            warehouse: WarehouseMapper.toModel(dto.warehouse),
            warehouseConnection: dto.warehouseConnection ? WarehouseConnectionMapper.toModel(dto.warehouseConnection) : undefined,
            quantity: dto.quantity,
            date: new Date(dto.date),
            type: dto.type as MutationType,
            referenceType: dto.referenceType
        };
    }
}
